export default {
  /**
   * trạng thái hồ sơ khi EnrollmentStatus = 4
   */
  AdmissionCompleteStatus: {
    Elect: 'Trúng tuyển', // trúng tuyển
    NotElect: 'Không trúng tuyển', // không trúng tuyển
    Admission: 'Đã nhập học', // đã nhập học
    ArrangeClass: 'Đã xếp lớp', // đã xếp lớp
  },

  /**
   * Trạng thái gửi trả hồ sơ hiển thị
   */
  ReturnProfileStatusDisplay: {
    NotReturn: 'Chưa gửi trả', // chưa gửi trả
    Return: 'Đã gửi trả', // đã gửi trả
  },

  /**
   * Trạng thái hồ sơ
   */
  EnrollmentStatus: {
    WaitReceive: 'Chờ tiếp nhận',
    WaitUpdate: 'Cần bổ sung',
    WaitAdmission: 'Chờ xét tuyển',
    // ReachCriteria: 'Đạt tiêu chí',
    Elect: 'Trúng tuyển',
    NotElect: 'Không trúng tuyển',
    Admission: 'Đã nhập học',
  },

  NotifyResult: {
    Sent: 'Đã gửi', // Đã gửi
    UnSend: 'Chưa gửi', // Chưa gửi
  },

  /**
   * Hình thức nộp
   */
  ProfileType: {
    Offline: 'Trực tiếp',
    Online: 'Trực tuyến',
  },

  /**
   * Trạng thái của form
   */
  FormState: {
    Add: 'Thêm',
    View: 'Xem',
    Edit: 'Sửa',
    Duplicate: 'Nhân bản',
    QuickAdd: 'Thêm nhanh',
    Remove: 'Xóa',
  },
  /**
   * Giới tính
   */
  Gender: {
    Female: 'Nữ',
    Male: 'Nam',
    Other: 'Khác',
  },

  /**
   * toán tử filter
   */
  FilterOperator: {
    Contains: 'Chứa',
    Notcontains: 'Không chứa',
    StartsWith: 'Bắt đầu với',
    EndsWith: 'Kết thúc với',
    Null: '(Trống)',
    NotNull: '(Không trống)',
    Equals: 'Bằng',
    NotEquals: 'Khác',
    GreaterThan: 'Lớn hơn',
    GreaterThanEquals: 'Lớn hơn hoặc bằng',
    LessThan: 'Nhỏ hơn',
    LessThanEquals: 'Nhỏ hơn hoặc bằng',
    Between: 'Trong khoảng',
  },

  /**
   * Diện khuyến khích/ưu tiên
   */
  PolicyType: {
    Encourage: 'Diện khuyến khích',
    Priority: 'Diện ưu tiên',
  },

  Period: {
    ThisDay: 'Hôm nay',
    ThisWeek: 'Tuần này',
    FirstWeekToPresent: 'Đầu tuần tới hiện tại',
    ThisMonth: 'Tháng này',
    FirstMonthToPresent: 'Đầu tháng tới hiện tại',
    ThisQuarter: 'Quý này',
    FirstQuarterToPresent: 'Đầu quý tới hiện tại',
    ThisYear: 'Năm nay',
    FirstYearToPresent: 'Đầu năm tới hiện tại',
    SixFirstMonth: 'Sáu tháng đầu năm',
    SixLastMonth: 'Sáu tháng cuối năm',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    FiscalI: 'Quý 1',
    FiscalII: 'Quý 2',
    FiscalIII: 'Quý 3',
    FiscalIV: 'Quý 4',
    Yesterday: 'Hôm qua',
    LastWeek: 'Tuần trước',
    LastMonth: 'Tháng trước',
    LastQuarter: 'Quý trước',
    LastYear: 'Năm trước',
    Tomorrow: 'Ngày mai',
    NextWeek: 'Tuần sau',
    NextMonth: 'Tháng sau',
    NextQuarter: 'Quý sau',
    NextYear: 'Năm sau',
    Custom: 'Tùy chọn',
  },
  Pagination: {
    // Two: '2 bản ghi trên 1 trang',
    Ten: '10 bản ghi/trang',
    Twen: '20 bản ghi/trang',
    Thir: '30 bản ghi/trang',
    Fif: '50 bản ghi/trang',
    Hunder: '100 bản ghi/trang',
    TwoHunder: '200 bản ghi/trang',
  },
  ReportPeriod: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: '6 tháng đầu năm',
    SecondHalfYear: '6 tháng cuối năm',
    Year: 'Cả năm',
    ThisMonth: 'Tháng này',
    ThisQuarter: 'Quý này',
    Custom: 'Tùy chọn',
  },
  ReportCre: {
    MonthDecember: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: '6 tháng đầu năm',
    SecondHalfYear: '6 tháng cuối năm',
    Year: 'Cả năm',
  },

  /**
   * Ký tự ngăn cách
   */
  Separator: {
    Dot: '. (dấu chấm)',
    Comma: ', (dấu phẩy)',
  },
  /**
   * Định dạng số dương
   */
  PositiveFormat: {
    $n: '$n',
    '$ n': '$ n',
    n$: 'n$',
    'n $': 'n $',
  },
  /**
   * Định dạng số âm
   */
  NegativeFormat: {
    '($n)': '($n)',
    '-$n': '-$n',
    '$-n': '$-n',
    '$n-': '$n-',
    '(n$)': '(n$)',
    '-n $': '-n $',
    'n-$': 'n-$',
    'n $-': 'n $-',
    '-$ n': '-$ n',
    '$ n-': '$ n-',
    'n- $': 'n- $',
    '($ n)': '($ n)',
    '(n $)': '(n $)',
  },
  /**
   * Kí hiệu âm
   */
  NegativeSign: {
    '(n)': '(n)',
    '-n': '-n',
    '- n': '- n',
    'n-': 'n-',
    'n -': 'n -',
  },
  /**
   * Loại công thức
   */
  ColumnDataType: {
    // Hệ số
    Coefficient: 'Hệ số',
    // Tỷ lệ
    Rate: 'Tỷ lệ',
    // Khác
    Other: 'Khác',
  },

  /**
   * Mã lỗi Validate
   */
  ValidateCode: {
    Required: 'Nhập thiếu thông tin',
    EditVersion: 'Dữ liệu đã bị thay đổi bởi người dùng khác',
    Duplicate: 'Dữ liệu đã tồn tại trong hệ thống',
    Arise: 'Danh mục đã có phát sinh',
    System: 'Dữ liệu thuộc hệ thống',
  },

  /**
   * Cấp học
   */
  SchoolLevel: {
    KinderGarden: 12, // Nhà trẻ
    Hope: 11, // Mẫu giáo
    PlaySchool: 0, // Mầm non
    Elementary: 1, // Tiểu học
    Junior: 2, // THCS
    Senior: 3, // THPT
    LienCap12: 4, // Trường liên cấp 1,2
    LienCap23: 5, // Trường liên cấp 2,3
    LienCap123: 6, // Trường liên cấp 1,2,3
    TrungCapCN: 7, // Trường Trung cấp chuyên nghiệp
  },

  SchoolLevelDisplay: {
    PlaySchool: 'Mầm non',
    Elementary: 'Tiểu học',
    Junior: 'THCS',
    Senior: 'THPT',
  },

  SchoolLevelBanner: {
    PlaySchool: 'Mamnon.png',
    Elementary: 'TH.png',
    Junior: 'THCS.png',
    Senior: 'THPT.png',
  },
}
